import { useEffect, useRef, useState } from "react";

export function useSearchTextInputControls(defaultSearchQueryValue?: string) {
	const [showSearchTextInput, setShowSearchTextInput] = useState(
		Boolean(defaultSearchQueryValue)
	);
	const searchRef = useRef<HTMLInputElement | null>(null);

	// Focus the search input when the user clicks the search icon, but *NOT* if there is a default
	// search query and this is the first time the component is rendered! This is to prevent this
	// search input from stealing the focus the first time a canvas is loaded.
	const [firstTimeRendered, setFirstTimeRendered] = useState(true);
	useEffect(() => {
		if (!firstTimeRendered && showSearchTextInput) {
			searchRef.current?.focus();
		}
		setFirstTimeRendered(false);
	}, [
		showSearchTextInput,
		// IMPORTANT: Do *NOT* include `firstTimeRendered` in this dependency array. This will cause
		// the input to be focused when a canvas is first loaded, which is not what we want.
	]);
	return { searchRef, showSearchTextInput, setShowSearchTextInput };
}
